"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'UserSearchInput',
  data: function data() {
    return {
      tableFromNew: this.value
    };
  },
  props: {
    value: {
      type: Object,
      default: {}
    },
    showReceiver: {
      // 是否显示"收货人"查询项（仅订单相关页面使用）
      type: Boolean,
      default: false
    }
  },
  watch: {
    tableFromNew: {
      handler: function handler(newVal) {
        this.$emit('input', newVal);
      },
      deep: true
    }
  },
  methods: {
    handleChangeType: function handleChangeType() {
      this.tableFromNew.content = '';
    },
    handleChangeContent: function handleChangeContent(event) {
      if (this.tableFromNew.searchType === 'phone' || this.tableFromNew.searchType === 'uid') this.tableFromNew.content = event.replace(/[^0-9]/g, '');
      if (this.tableFromNew.content > 99999999999) {
        this.tableFromNew.content = ''; // 设置最大值为100
      }
    },
    // 回车搜索
    handleSearchList: function handleSearchList() {
      this.$emit('keyupEnterSearch');
    }
  }
};